<template>
  <b-sidebar
    id="add-new-centro-trabajo-sidebar"
    :visible="isAddNewCentroTrabajoSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-centro-trabajo-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Registrar Nuevo Centro de Trabajo
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >


        <validation-provider
            #default="validationContext"
            name="Malla"
            rules="required"
          >
            <b-form-group
              label="Malla"
              label-for="centro_costo_padre_id"
            >
              <b-form-select
                id="centro_costo_padre_id"
                v-model="centroCostoData.centro_costo_padre_id"
                :options="mallas"
                :state="getValidationState(validationContext)"
                trim>
              </b-form-select>

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          
          <!-- Full Name -->
          <validation-provider
            #default="validationContext"
            name="Nombre"
            rules="required"
          >
            <b-form-group
              label="Nombre del Centro de Trabajo"
              label-for="nombre"
            >
              <b-form-input
                id="nombre"
                v-model="centroCostoData.nombre"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="..."
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Email -->
          <validation-provider
            #default="validationContext"
            name="Descripcion"
            rules="required"
          >
            <b-form-group
              label="Descripcion"
              label-for="descripcion"
              
            >
              <b-form-input
                id="email"
                v-model="centroCostoData.descripcion"
                placeholder="..."
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Password -->
          <validation-provider
            #default="validationContext"
            name="Precio x Hora"
            rules="required"
          >
            <b-form-group
              label="Pago por Hora"
              label-for="pago_por_hora"
            >
              <b-form-input
                id="pago_por_hora"
                v-model="centroCostoData.pago_por_hora"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>


          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              Registrar
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,BFormSelect
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import countries from '@/@fake-db/data/other/countries'
import store from '@/store'
import axios from '@axios'

export default {
  components: {
    BFormSelect,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewCentroTrabajoSidebarActive',
    event: 'update:is-add-new-centro-trabajo-sidebar-active',
  },
  props: {
    isAddNewCentroTrabajoSidebarActive: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      mallas : [],
      required,
      alphaNum,
      email,
      countries,
    }
  },
  setup(props, { emit }) {
    const blankData = {
      nombre: '',
      descripcion: '',
      pago_por_hora: 0.0,
      centro_costo_padre_id: null,
    }

    const centroCostoData = ref(JSON.parse(JSON.stringify(blankData)))
    const resetcentroCostoData = () => {
      centroCostoData.value = JSON.parse(JSON.stringify(blankData))
    }

    const onSubmit = () => {
      store.dispatch('app-centro-trabajo/addUser', centroCostoData.value)
        .then(() => {
          emit('refetch-data')
          emit('update:is-add-new-centro-trabajo-sidebar-active', false)
        })
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetcentroCostoData)

    return {
      centroCostoData,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
  mounted() {
    this.getMallas()
  },
  methods: {
    getMallas() {
      axios.get('https://lrcdigital.com/nomina/api/cat-mallas')
        .then(response => {
          this.mallas = response.data.data.map((item) => {
            return {
              value: item.Codigo,
              text: item.Nombre,
            }
          });
          this.mallas.unshift({
            value: null,
            text: 'Selecciona una malla',
          })
        })
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
